/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.UserSyncExcelSettings = factory(root.ForStractionServiceApi.ApiClient);
  }
}(this, function(ApiClient) {
  'use strict';




  /**
   * The UserSyncExcelSettings model module.
   * @module model/UserSyncExcelSettings
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new <code>UserSyncExcelSettings</code>.
   * @alias module:model/UserSyncExcelSettings
   * @class
   */
  var exports = function() {
    var _this = this;








  };

  /**
   * Constructs a <code>UserSyncExcelSettings</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/UserSyncExcelSettings} obj Optional instance to populate.
   * @return {module:model/UserSyncExcelSettings} The populated <code>UserSyncExcelSettings</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (data.hasOwnProperty('IsActive')) {
        obj['IsActive'] = ApiClient.convertToType(data['IsActive'], 'Boolean');
      }
      if (data.hasOwnProperty('UseExternalIDForUsers')) {
        obj['UseExternalIDForUsers'] = ApiClient.convertToType(data['UseExternalIDForUsers'], 'Boolean');
      }
      if (data.hasOwnProperty('UseExternalIDForTeams')) {
        obj['UseExternalIDForTeams'] = ApiClient.convertToType(data['UseExternalIDForTeams'], 'Boolean');
      }
      if (data.hasOwnProperty('LastUpdate')) {
        obj['LastUpdate'] = ApiClient.convertToType(data['LastUpdate'], 'Date');
      }
      if (data.hasOwnProperty('LastError')) {
        obj['LastError'] = ApiClient.convertToType(data['LastError'], 'String');
      }
      if (data.hasOwnProperty('ImportInProgress')) {
        obj['ImportInProgress'] = ApiClient.convertToType(data['ImportInProgress'], 'Boolean');
      }
      if (data.hasOwnProperty('ID')) {
        obj['ID'] = ApiClient.convertToType(data['ID'], 'Integer');
      }
    }
    return obj;
  }

  /**
   * @member {Boolean} IsActive
   * @default false
   */
  exports.prototype['IsActive'] = false;
  /**
   * @member {Boolean} UseExternalIDForUsers
   * @default false
   */
  exports.prototype['UseExternalIDForUsers'] = false;
  /**
   * @member {Boolean} UseExternalIDForTeams
   * @default false
   */
  exports.prototype['UseExternalIDForTeams'] = false;
  /**
   * @member {Date} LastUpdate
   */
  exports.prototype['LastUpdate'] = undefined;
  /**
   * @member {String} LastError
   * @default ''
   */
  exports.prototype['LastError'] = '';
  /**
   * @member {Boolean} ImportInProgress
   * @default false
   */
  exports.prototype['ImportInProgress'] = false;
  /**
   * @member {Integer} ID
   * @default 0
   */
  exports.prototype['ID'] = 0;



  return exports;
}));


